import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/InstructorViewAssignmentFeedback/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { IconButton, MenuItem, Select, Stack, styled } from 'shell/components';
import { getUserPreferredFullName } from 'utils/helper';

const Header = () => {
    const { device } = useViewport();
    const { t } = useTranslation('assignment');

    const {
        currentFeedbackItem,
        students,
        currentStudentIndex,
        studentsWithoutFeedback,
        onClickBack,
        onChangeStudent,
        onClickPrevStudent,
        onClickNextStudent,
    } = useContext(PageContext);

    return (
        <RootStack
            alignItems={device === 'mobile' ? 'flex-end' : 'center'}
            device={device}
            direction={device === 'mobile' ? 'column-reverse' : 'row'}
            justifyContent={'space-between'}
        >
            <Stack sx={{ width: '100%' }} alignItems={'flex-end'} direction={'row'} spacing={2}>
                <CustomSelect
                    device={device}
                    label={t('viewing-students', 'Viewing {{currentStudent}}/{{totalStudents}} Students', {
                        currentStudent: currentStudentIndex + 1,
                        totalStudents: students.length,
                    })}
                    labelId={'student-select'}
                    value={
                        students.find(
                            ({ owner_account_id }) => owner_account_id === currentFeedbackItem.owner_account_id
                        ).owner_account_id
                    }
                    onChange={(e) => onChangeStudent(e.target.value)}
                >
                    {students.map((accountUser) => (
                        <MenuItem key={accountUser.owner_account_id} value={accountUser.owner_account_id}>
                            {getUserPreferredFullName(accountUser)}
                        </MenuItem>
                    ))}
                    {studentsWithoutFeedback.map((accountUser) => (
                        <MenuItem key={accountUser.owner_account_id} disabled value={accountUser.owner_account_id}>
                            {getUserPreferredFullName(accountUser)}
                        </MenuItem>
                    ))}
                </CustomSelect>
                <IconButton
                    aria-label={'view previous student'}
                    disabled={!currentStudentIndex}
                    kind={'chevronLeft'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClickPrevStudent}
                />
                <IconButton
                    aria-label={'view next student'}
                    disabled={currentStudentIndex === students.length - 1}
                    kind={'chevronRight'}
                    size={'medium'}
                    variant={'square'}
                    onClick={onClickNextStudent}
                />
            </Stack>
            <IconButton aria-label={'close'} kind={'exit'} size={'medium'} variant={'square'} onClick={onClickBack} />
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme, device }) => {
    return {
        position: 'absolute',
        top: 0,
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: device === 'mobile' ? '129px' : '81px',
        padding: device === 'desktop' ? theme.spacing(3, 5) : theme.spacing(3, 4),
        background: theme.palette.ensightful.primary[50],
    };
});

const CustomSelect = styled(Select)(({ device }) => {
    return {
        width: device === 'mobile' ? '100%' : '350px',
    };
});

export default Header;
